<div class="verticalFlex background align-items-center ">
  @if (isSubmitting()) {
    <div class="submittingOverlay">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
  <div class="panel">
    <div>

      <app-branding-header
        [headerImage]="loaService.getBrandHeaderImage(brandDetails)"
        [primaryColor]="loaService.getBrandPrimaryColour(brandDetails)"
        [isRenewal]="isRenewal"
      ></app-branding-header>

      <div class="my-3">
        <app-info-box [currentStage]="'authorise'" [brandColour]="loaService.getBrandPrimaryColour(brandDetails)" [siteCount]="dataSource.data.length" [isRenewal]="isRenewal"></app-info-box>
      </div>

      <div>
        <div [style.color]="loaService.getBrandPrimaryColour(brandDetails)"
             class="sectionTitle">Letter of authority
        </div>
        <div class="my-3">
          <div class="mb-3">
            <input type="text" class="form-control" placeholder="Full Name" [(ngModel)]="loa.signatory.name" required>
          </div>
          <div class="row mb-3">
            <div class="col">
              <input type="text" class="form-control" placeholder="Job Title" [(ngModel)]="loa.signatory.jobTitle"
                     required>
            </div>
            <div class="col">
              <input type="text" class="form-control" placeholder="Company Name"
                     [(ngModel)]="loa.signatory.company" required>
            </div>
          </div>
          <div class="mb-3">
            <input type="email" class="form-control" placeholder="Email" [value]="loa.signatory.email" disabled>
          </div>
        </div>
      </div>


      <div class="mt-3">
        <div [style.color]="loaService.getBrandPrimaryColour(brandDetails)"
             class="sectionTitle">MPANs/ MPRNs included
        </div>

        <div>

          <div class="d-flex meterCountBox mt-2 d-flex align-items-center ">
            <fa-icon class="green pe-2" [icon]="['far', 'check-circle']"></fa-icon>
            <div class="green">You are authorising <b>{{ enabledCount }}</b> meters</div>
          </div>

          <div class="py-3">
            <mat-table mat-table [dataSource]="dataSource" class="mat-elevation-z0 ">
              <ng-container matColumnDef="building">
                <mat-header-cell *matHeaderCellDef
                                 class="matSortHeaderFormat justify-content-start leftAlignedHeaders">Building
                </mat-header-cell>
                <mat-cell mat-cell
                          *matCellDef="let element">
                  <div class="d-flex align-self-start">
                    {{ element.buildingName }}
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="consentDate">
                <mat-header-cell *matHeaderCellDef
                                 class="matSortHeaderFormat justify-content-start leftAlignedHeaders">
                  <div class="d-flex flex-column">
                    <div>Consent Date</div>
                    <div class="consent-date-subtext" style="text-transform: none;">Occupied building on or before this
                      date
                    </div>
                  </div>
                </mat-header-cell>
                <mat-cell mat-cell
                          *matCellDef="let element">
                  <div class="d-flex align-self-start">
                    @if (element.isDateEditable) {
                      <app-date-picker
                        class="pt-2"
                        [value]="element.consentDate"
                        [brandColor]="loaService.getBrandPrimaryColour(brandDetails)"
                        [minDate]="fallbackDate"
                        (valueChange)="element.consentDate = $event"
                      ></app-date-picker>
                    } @else {
                      {{ element.consentDate }}
                    }
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="meters">
                <mat-header-cell *matHeaderCellDef
                                 class="matSortHeaderFormat justify-content-start leftAlignedHeaders">Meters
                </mat-header-cell>
                <mat-cell mat-cell
                          *matCellDef="let element">
                  <div class="d-flex flex-column">
                    @for (meter of element.meters; track meter.meterUuid) {
                      <div class="d-flex align-items-center form-check">
                        <input class="form-check-input me-2" type="checkbox"
                               [id]="meter.meterUuid"
                               [checked]="meterEnabledState.get(meter.meterUuid)"
                               (change)="toggleMeterState(meter.meterUuid)">
                        <label class="d-flex align-items-center cursorPointer" [for]="meter.meterUuid">
                          <fa-icon
                            [class.elecColour]="meter.meterType === 'elec'"
                            [class.gasColour]="meter.meterType === 'gas'"
                            [icon]="['fas', meter.meterType === 'gas' ? 'fire' : 'bolt']"></fa-icon>
                          <span class="ps-2" [class.strikethrough]="!meterEnabledState.get(meter.meterUuid)">{{ meter.ingressId }}</span>
                        </label>
                      </div>
                    }
                  </div>

                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="noRecords">
                <mat-cell *matFooterCellDef class="boldFont"
                          style="text-align: center;justify-content: center">
                  No LoA's found
                </mat-cell>
              </ng-container>


              <mat-header-row class="custom-mat-header-row"
                              *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

              <mat-row
                mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

              <mat-footer-row
                [hidden]="dataSource != null && dataSource.filteredData != null && dataSource.filteredData.length > 0"
                *matFooterRowDef="['noRecords']"
                colspan="2"></mat-footer-row>
            </mat-table>

          </div>


        </div>
        <div class="pdfHide tableWarningBox py-1 d-flex ">
          <fa-icon class="px-2 tableWarningIcon" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
          <div class="tableWarningText align-self-center">Please review the move in dates for any new buildings to
            ensure you authorise access to your data correctly. This date is by default set at 36 months, and you
            should change it if you have moved into the premises after that.
          </div>
        </div>
      </div>

      <div class="pt-3 pb-1">
        <div [style.color]="loaService.getBrandPrimaryColour(brandDetails)"
             [ngClass]="{'pdfHide': uploadedFiles.length === 0}"
             class="sectionTitle">SUPPORTING EVIDENCE / FILE UPLOADS
        </div>

        <div class="pdfHide supportingDocsText">Upload supporting evidence: e.g. utility bills or documents that prove
          you have authority to view the data.
        </div>

        <div class="pdfHide docsBox mt-2 px-4 d-flex align-items-center justify-content-center flex-column"
             (dragover)="onDragOver($event)" (drop)="onDrop($event)">
          <fa-icon class="paperclip px-4 pt-4 pb-2" [style.color]="loaService.getBrandPrimaryColour(brandDetails)"
                   [icon]="['fas', 'paperclip-vertical']"></fa-icon>
          <div class="d-flex pb-4">
            <div class="dragDropText">Drag and drop or</div>
            <div class="chooseFiles px-1" [style.color]="loaService.getBrandPrimaryColour(brandDetails)"
                 (click)="fileInput.click()">
              choose file(s)
            </div>
            <div class="dragDropText">to Upload</div>
          </div>
          <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" multiple>
        </div>

      </div>
      <div class="fileNamesContainer mt-2">
        @for (file of uploadedFiles; track i; let i = $index) {
          <div class="p-2 d-flex align-items-center">
            <fa-icon [icon]="['far', 'file-lines']"></fa-icon>
            <div class="ps-2 fileText">{{ file.name }}</div>
            <div class="flex-1"></div>
            <div class="cursorPointer pdfHide" (click)="removeFile(i)">
              <fa-icon [icon]="['far', 'circle-xmark']"></fa-icon>
            </div>
          </div>
        }
      </div>

      <div class="pt-3">
        <div [style.color]="loaService.getBrandPrimaryColour(brandDetails)"
             class="sectionTitle">Data Authorisation / T&Cs
        </div>

        <div class="py-2">
          <app-terms-box [brandName]="loa.brandName"></app-terms-box>
        </div>

        <div class="checkboxes">
          <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" id="confirmOwner" [(ngModel)]="confirmAccountOwner"
                   required>
            <label class="form-check-label termsCheckboxFont" for="confirmOwner">
              I confirm that our business is the legal account owner for the listed meters, or that I have provided
              evidence to show I have the right to access their data.
            </label>
          </div>
          <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" id="authProcessing" [(ngModel)]="authorizeProcessing"
                   required>
            <label class="form-check-label termsCheckboxFont" for="authProcessing">
              I authorise @if (loa.brandName && !loaService.isGridEdge(loa.brandName)) { {{ loa.brandName }} and }Grid Edge to access and process my energy data for analysis and reporting as described in the Terms and Conditions.
            </label>
          </div>
          <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" id="agreePrivacy" [(ngModel)]="agreePrivacyPolicy" required>
            <label class="form-check-label termsCheckboxFont" for="agreePrivacy">
              I have read and agree to the
              <a [style.color]="loaService.getBrandPrimaryColour(brandDetails)"
                 style="text-decoration: underline; cursor: pointer;"
                 [href]="privacyPolicyLink"
                 target="_blank"
                 rel="noopener noreferrer">Privacy Policy</a>.
            </label>
          </div>
        </div>
      </div>


      <div class="mt-3 d-flex pdfHide submitBox">

        <div class="d-flex flex-1 flex-column">
          <div class="submitTitle">
            @if (isRenewal) {
              All looking good?
            } @else {
              Ready to see your {{ dataSource.data.length === 1 ? 'building' : 'buildings' }}?
            }
          </div>
          <div class="submitSubTitle">
            @if (isRenewal) {
              Keep making better energy decisions.
            } @else {
              Start making better energy decisions immediately.
            }
          </div>
        </div>

        <div class="d-flex px-3 py-2 brandButton"
             [class.disabled]="!isFormValid"
             [style.background]="loaService.getBrandPrimaryColour(brandDetails)"
             (click)="submit()">
          <fa-icon class="whiteColour pe-2" [icon]="['fas', 'check']"></fa-icon>
          <div class="whiteColour brandButtonFont">Authorise Energy Tracker</div>
        </div>
      </div>

    </div>
  </div>
  <app-footer class="py-2"></app-footer>

</div>
